module.exports = __webpack_public_path__ + "img/康复展.05a7d41a.jpg";